import React from 'react'
import { connect } from 'react-redux'
import ServerStatus from './ServerStatus.jsx'
import ScrollToTop from './ScrollToTop.jsx'
import Button from '../components/Button.jsx'
import FooterBtnContainer from '../containers/FooterBtnContainer.jsx'

const NotFound = props => (
    <div className="not-found">
        <div className="not-found-container">
            <div className="container">
                <ScrollToTop />
                <ServerStatus statusCode={404} />
                <div className="row">
                    <div className="col-md-5">
                        <div className="not-found-img-container">
                            <img className="not-found-img-container__img" src="/images/bck/BED_404.jpg" />
                        </div>
                    </div>
                    <div className="col-md-7">
                        <div className="not-found-info">
                            <h1 className="not-found-info__404">404</h1>
                            <h2 className="not-found-info__title">{props.langData.title}</h2>
                            <h3 className="not-found-info__text">{props.langData.text}</h3>
                            <div className="not-found-info__btn">
                                <Button type="yellow" text={props.langData.btnText} link="/usluge" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <FooterBtnContainer />
    </div>
)

const mapStateToProps = state => ({
    langData: state.langData.notFound
})

export default connect(mapStateToProps)(NotFound)



// WEBPACK FOOTER //
// ./src/scripts/utils/NotFound.jsx